import Switch from 'components/Switch';
import React from 'react';

export const Switches = ({
  tuesdayDrawEnabled,
  setTuesdayDrawEnabled,
  fridayDrawEnabled,
  setFridayDrawEnabled,
  onAnyUserAction = () => {},
  glowColor,
}) => {
  return (
    <div className="switches fullWidth grid columns-2">
      <div className="switchContainer">
        <Switch
          glowColor={glowColor}
          design3
          enabled={tuesdayDrawEnabled}
          onToggle={() => {
            onAnyUserAction();
            const newSetting = !tuesdayDrawEnabled;
            setTuesdayDrawEnabled(newSetting);
            if (newSetting === false && fridayDrawEnabled === false) {
              setFridayDrawEnabled(true);
            }
          }}
          id={undefined}
          disabled={undefined}
          withoutFill={undefined}
          optionalSliderImage={undefined}
          customOnOffLabels={undefined}
          style={undefined}
        />
        <p className="medium bold noMargin">Tuesday</p>
      </div>

      <div className="switchContainer">
        <Switch
          glowColor={glowColor}
          design3
          enabled={fridayDrawEnabled}
          onToggle={() => {
            onAnyUserAction();
            const newSetting = !fridayDrawEnabled;
            setFridayDrawEnabled(newSetting);
            if (newSetting === false && tuesdayDrawEnabled === false) {
              setTuesdayDrawEnabled(true);
            }
          }}
          id={undefined}
          disabled={undefined}
          withoutFill={undefined}
          optionalSliderImage={undefined}
          customOnOffLabels={undefined}
          style={undefined}
        />
        <p className="medium bold noMargin">Friday</p>
      </div>

      <style jsx>
        {`
          .switchContainer {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0;
            width: 100%;
          }

          @media (max-width: 350px) {
            :global(.drawDaysSelector .switch) {
              margin-right: 0.7em;
            }
          }
        `}
      </style>
    </div>
  );
};
